// frontend/src/apiConfig.ts
// This file centralizes the API URL configuration with a robust fix.

// It reads the URL from a 'REACT_APP_API_URL' environment variable.
let apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Robustness Fix: Ensure the URL starts with http:// or https://
// This prevents the browser from treating it as a relative path.
if (apiUrl && !apiUrl.startsWith('http')) {
  apiUrl = `https://${apiUrl}`;
}

const API_URL = apiUrl;


export { API_URL };
